import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ListRouteReattachService {
  private pendingReattach = false;

  markPendingReattach(): void {
    this.pendingReattach = true;
  }

  consumePendingReattach(): boolean {
    if (!this.pendingReattach) {
      return false;
    }
    this.pendingReattach = false;
    return true;
  }

  clear(): void {
    this.pendingReattach = false;
  }
}
